import { UseDisclosureReturn } from '@chakra-ui/react';
import { BaseFormDialog, useHookForm } from '@invara-dev/react-base';
import { NewUnverifiedHotelModel } from '../../../../features/activities/hotelSearch/addHotel/types';
import { useNewUnverifiedHotelHotelSearchMutation } from '../../../../features/activities/hotelSearch/api/useNewUnverifiedHotelHotelSearchMutation';
import { HotelSearchResultCombined } from '../../../../features/activities/hotelSearch/types/hotelSearchResultCombined';
import { useAddUnverifiedHotelFields } from '../../../../features/activities/hotelSearch/addHotel/utils/useAddUnverifiedHotelFields.tsx';

type Props = {
  activityId: number;
  disclosure: UseDisclosureReturn;
  onHotelAdded: (model: HotelSearchResultCombined) => void;
  forQuote: boolean;
};

export const AddNewHotelModal = (props: Props) => {
  const { formMethods } = useHookForm<NewUnverifiedHotelModel>();
  const addNewHotelMutation = useNewUnverifiedHotelHotelSearchMutation();
  const fields = useAddUnverifiedHotelFields(formMethods);
  return (
    <BaseFormDialog<NewUnverifiedHotelModel>
      onSubmit={async (model) => {
        const newHotelSearchResult = await addNewHotelMutation.mutateAsync({
          activityId: props.activityId,
          model,
          forQuote: props.forQuote
        });
        props.onHotelAdded(newHotelSearchResult);
      }}
      isLoading={addNewHotelMutation.isPending}
      formMethods={formMethods}
      disclosure={props.disclosure}
      header={'Add New Hotel'}
      fields={fields}
      dragDialog={{
        initialH: 800,
        initialW: 800
      }}></BaseFormDialog>
  );
};
